import RadioFieldset from "../../audi-ui-components/RadioFieldset";
import {
  requestTypes,
} from './CVOConstants';
import { gtmPush } from "../../functions/gtm";
import { DEFAULT_THEME } from "../../constants";

const StepReason = ({ values, errors, touched, setFieldValue, setFieldTouched, theme = DEFAULT_THEME }) => {
  return (
    <div>
      <p className="aui-headline-4 mb-4">Reason for change</p>
      <RadioFieldset name="requestType"
        options={[
          {label: requestTypes.NO_LONGER_OWN, value: requestTypes.NO_LONGER_OWN},
          {label: requestTypes.NEW_OWNER, value: requestTypes.NEW_OWNER},
          {label: requestTypes.PERSONAL_DETAILS_CHANGED, value: requestTypes.PERSONAL_DETAILS_CHANGED},
          {label: requestTypes.WRITTEN_OFF, value: requestTypes.WRITTEN_OFF}
        ]}
        value={values.requestType}
        onChange={(v) => {
          setFieldValue('requestType', v);
          gtmPush("cvoReasonForChange", "ChangeVehicleOwnership", v);
        }}
        onBlur={() => { setFieldTouched('requestType'); }}
        isInvalid={errors.requestType && touched.requestType}
        invalidMessage={errors.requestType}
        className="mb-5 stacked"
        theme={theme === "dark" ? "light" : null}
      />
    </div>
  );
};

export default StepReason;
